// eslint-disable-next-line max-params
export function normalizeLoadedFormValues(viewers, form, values, recursive = true, addressTemplates) {
    if (!form?.fields) {
        return {};
    }
    const normalizedValues = form.fields.reduce((result, field)=>{
        const fieldTarget = field.target;
        if (!fieldTarget) {
            return result;
        }
        const fieldValue = values?.[fieldTarget];
        const fieldType = field.view?.fieldType;
        const nestedForm = field.view?.form;
        if (recursive && nestedForm) {
            result[fieldTarget] = normalizeLoadedFormValues(viewers, nestedForm, fieldValue, false, addressTemplates);
        } else {
            const normalizer = viewers[fieldType]?.normalizeLoadedValue;
            if (normalizer) {
                result[fieldTarget] = normalizer({
                    field,
                    fieldValue,
                    addressTemplates,
                    viewers
                });
            } else {
                result[fieldTarget] = fieldValue;
            }
        }
        return result;
    }, {});
    return normalizedValues;
}

//# sourceMappingURL=normalize-loaded-form-values.js.map